import React from 'react';
import styled from 'styled-components';
import StainBackground from '../stain-background';
import Socials from '../socials';

const SocialWidget = ({ className }) => (
  <StainBackground className={className}>
    <Title>Blijf op de hoogte van wat ik doe!</Title>
    <Socials variant="widget" />
  </StainBackground>
);

const Title = styled.h3`
  margin: 0 0 30px 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    font-size: 2rem;
  }
`;

export default styled(SocialWidget)``;
